import { GraphDataParam } from './enums/graphDataParam'

type TempViewLastEvent = string

export const LAST_EVENT_SERIES: TempViewLastEvent = 'last_event'

export type TempViewSeries = GraphDataParam | TempViewLastEvent
